import {defineStore} from "pinia";
import api from "../services/api.js";
import {useModalStore} from "./modal.js";

export const useChatStore = defineStore("chats", {
    state: () => ({
        _chats: null,
        _chat: null,
        _reply_message: null,
        _stats: null
    }),
    getters: {
        chats: (state) => state._chats,
        chat: (state) => state._chat,
        reply_message: (state) => state._reply_message,
        stats: (state) => state._stats
    },
    actions: {
        async createChat(uuid, template_name) {
            const response = await api.post('chats', {uuid, template_name})
            this._chat = response.data
        },
        async createManualChat(external_id, profile_name, template_name) {
            const response = await api.post('chats/manual', {external_id, profile_name, template_name})
            this._chat = response.data
        },
        async getChats(params) {
            const response = await api.get('chats', params)
            this._chats = response.data
        },
        async getStats(params) {
            const response = await api.get('chats/stats', params)
            this._stats = response.data
        },
        resetChats() {
            this._chats = null
        },
        async getChat(chatId) {
            const response = await api.get(`chats/${chatId}`);
            this._chat = response.data
        },
        async assignChat(chatId, userId) {
            const response = await api.post(`chats/${chatId}/assign`, {assignee_id: userId})
            this._chat = response.data
        },
        async bulkAssignChat(chats, userId) {
            const response = await api.post(`chats/bulk-assign`, {chats, assignee_id: userId})
            this._chat = response.data
        },
        async completeChat(chatId) {
            const response = await api.post(`chats/${chatId}/complete`)
            this._chat = response.data
        },
        async bulkCompleteChats(chats) {
            await api.post(`chats/bulk-complete`, {chats})
        },
        async addMessage(content) {
            const modalStore = useModalStore()
            const formData = new FormData();
            formData.append('content', content);

            if (this._reply_message) {
                formData.append('parent_id', this._reply_message.id);
            }

            if (modalStore.props.attachment) {
                formData.append('attachment', modalStore.props.attachment);
            }

            const response = await api.post(
                `chats/${this._chat.id}/messages`,
                formData,
                {headers: {'Content-Type': 'multipart/form-data'}}
            );

            this._chat.messages.push(response.data);
            this._reply_message = null;
            modalStore.props.attachment = null;
        },
        async sendTemplateMessage(template_name) {
            await api.post(`chats/${this._chat?.id}/messages/template-message`, {template_name})
        },
        async resendMessage(messageId) {
            await api.post(`chats/${this._chat?.id}/messages/${messageId}/resend`)
        },
        async addNote(chatId, note) {
            const response = await api.post(`chats/${chatId}/add-note`, {content: note})
            this._chat = response.data
        },
        async searchChats(query, status = null) {
            const response = await api.post('chats/search', {query, status})
            this._chats = response.data
        },
        async toggleContactBlock(chat_contact_id, reason) {
            const response = api.post(`chat-contacts/${chat_contact_id}/toggle-block`, {reason})
        },
        setReplyMessage(message) {
            this._reply_message = message
        }
    }
})
